import { existsAndNotEmpty } from "stentor-utils";



export type CMSType = "wix" | "wordpress" | "squarespace" | "joomla" | "godaddy";

/**
 * Determines which CMS the website is using
 *
 * @param technologies
 * @returns
 */
export function determineCMS(technologies: { installed?: boolean, technology: string }[]): CMSType {
    // CMS technology values:
    // "WordPress CMS"
    // "Wix CMS"
    // "Joomla Platform"
    // "SquareSpace CMS"
    // "GoDaddy Website Builder"

    if (!!existsAndNotEmpty(technologies) === false) {
        return undefined;
    }

    const wordpress = technologies.find((tech) => {
        return tech.technology === "WordPress CMS" && tech.installed;
    });

    if (wordpress) {
        return "wordpress";
    }

    const wix = technologies.find((tech) => {
        return tech.technology === "Wix CMS" && tech.installed;
    });

    if (wix) {
        return "wix";
    }

    const squarespace = technologies.find((tech) => {
        return tech.technology === "SquareSpace CMS" && tech.installed;
    });

    if (squarespace) {
        return "squarespace";
    }

    const joomla = technologies.find((tech) => {
        return tech.technology === "Joomla Platform" && tech.installed;
    });

    if (joomla) {
        return "joomla";
    }

    const godaddy = technologies.find((tech) => {
        return tech.technology === "GoDaddy Website Builder" && tech.installed;
    });

    if (godaddy) {
        return "godaddy";
    }
}